let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("auTAr")).then(() => parcelRequire('88hCk'));